import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupportedCodeLang } from '../domain/code-gen/code-lang.types';
import { DEFAULT_CODE_LANG } from '../domain/code-gen/code-lang.config';

@Injectable({
  providedIn: 'root'
})
export class CodeLangStateService {
  private readonly codeLangSub = new BehaviorSubject<SupportedCodeLang>(DEFAULT_CODE_LANG);
  
  readonly codeLang$: Observable<SupportedCodeLang> = this.codeLangSub.asObservable();

  get currentCodeLang(): SupportedCodeLang {
    return this.codeLangSub.getValue();
  }

  setCodeLang(codeLang: SupportedCodeLang): void {
    this.codeLangSub.next(codeLang);
  }
}
